/** @file storedDeflate: a valid zlib stream of uncompressed (stored) deflate blocks, pure TS. */
import { adler32 } from './adler32';

/** Largest payload of one stored block (its LEN field is 16 bits). */
const BLOCK = 65535;

/** `data` wrapped as zlib (RFC 1950) with stored blocks of ≤ 65535 bytes (RFC 1951 §3.2.4); no compression. */
export function storedDeflate(data: Uint8Array): Uint8Array {
  const blocks = Math.max(1, Math.ceil(data.length / BLOCK));
  const out = new Uint8Array(2 + blocks * 5 + data.length + 4);
  out[0] = 0x78; // CMF: deflate, 32 KB window
  out[1] = 0x01; // FLG: no dictionary, fastest; (0x78 << 8 | 0x01) % 31 === 0
  let o = 2;
  for (let k = 0; k < blocks; k++) {
    const start = k * BLOCK;
    const len = Math.min(BLOCK, data.length - start);
    out[o] = k === blocks - 1 ? 1 : 0; // BFINAL, BTYPE 00
    out[o + 1] = len & 0xff;
    out[o + 2] = len >>> 8;
    out[o + 3] = ~len & 0xff;
    out[o + 4] = (~len >>> 8) & 0xff;
    out.set(data.subarray(start, start + len), o + 5);
    o += 5 + len;
  }
  const sum = adler32(data);
  out.set([sum >>> 24, (sum >>> 16) & 0xff, (sum >>> 8) & 0xff, sum & 0xff], o);
  return out;
}
